import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "./ModalConfirmation.css";

const ModalConfirmation = ({
  title,
  question,
  mainAction,
  secondaryAction,
  mainButton,
  secondaryButton,
  handleShow,
  show,
}) => {

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={() => handleShow(false)}
      backdrop="static"
      keyboard={false}
      className="modal-confirmation"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{question}</Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          className="form-action modal-button  modal-cancel-button"
          onClick={() => {
            secondaryAction();
            handleShow(false);
          }}
        >
          {secondaryButton}
        </Button>
        <Button
          variant="primary"
          className="form-action form-action-primary modal-button  modal-confirmation-button"
          onClick={mainAction}
        >
          {mainButton}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmation;
